import { render, staticRenderFns } from "./crossRegion.vue?vue&type=template&id=ddbb9d9c"
import script from "./crossRegion.vue?vue&type=script&lang=js"
export * from "./crossRegion.vue?vue&type=script&lang=js"
import style0 from "./crossRegion.vue?vue&type=style&index=0&id=ddbb9d9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports